import React, { useEffect, useState } from "react";
import "../rejectDialog/RejectDialog.css";

const StatusConfirmDialog = ({
  open,
  title = "Are you sure you want to change status?",
  message = "",
  confirmLabel = "Confirm",
  onConfirm,
  onCancel,
}) => {
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (open) setComment("");
  }, [open]);

  if (!open) return null;

  return (
    <div className="reject-modal-overlay">
      <div className="reject-modal-content">
        <h2 className="reject-modal-title">{title}</h2>
        <div className="reject-modal-icon">
          <span>?</span>
        </div>
        {message ? (
          <p style={{ color: "#082a51", marginBottom: "16px" }}>{message}</p>
        ) : null}
        <div className="reject-modal-label">Add Note / Comments</div>
        <textarea
          className="reject-modal-textarea"
          placeholder="Write comments (optional)"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        <div className="reject-modal-actions">
          <button
            className="reject-modal-btn reject"
            onClick={() => onConfirm(comment.trim())}
          >
            {confirmLabel}
          </button>
          <button className="reject-modal-btn cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusConfirmDialog;

export const STATUS_LABELS = {
  1: "In Process",
  3: "Pending For Approval",
  4: "Approved",
  5: "Rejected",
  7: "Renewal",
  20: "Assigned to Company",
  in_process: "In Process",
  pending_for_approval: "Pending For Approval",
  approved: "Approved",
  rejected: "Rejected",
  descrepency_GB_GB: "Discrepancies",
  renewal: "Renewal",
  assign_to_company: "Assigned to Company",
};

export const STATUS_ROUTES = {
  1: "/in-process-applications",
  3: "/pending-applications",
  4: "/approved-applications",
  5: "/rejected-applications",
  7: "/renewals",
  20: "/discrepancies",
  in_process: "/in-process-applications",
  pending_for_approval: "/pending-applications",
  approved: "/approved-applications",
  rejected: "/rejected-applications",
  descrepency_GB_GB: "/discrepancies",
  renewal: "/renewals",
  assign_to_company: "/discrepancies",
};

export const getStatusRoute = (status) => STATUS_ROUTES[status] || null;
